import React, { useEffect, useState, useRef } from "react"
import ReactPlayer from "react-player"
import "./styles.scss"
import showreelCover from "../../../assets/images/homepage/showreel-cover.jpg"

const VideoComponent = () => {
  const [isPlaying, setIsPlaying] = useState(true)
  const [isActive, setIsActive] = useState(false)
  const [isMuted, setIsMuted] = useState(true)
  const [wasPlayed, setWasPlayed] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const ref = useRef()
  const refPlayer = useRef()

  function stopVideo() {
    setIsPlaying(false)
  }

  function closeModal() {
    setShowModal(false)
    if (typeof document !== undefined) {
      document.querySelector("body").classList.remove("overflow")
    }
  }

  useOnClickOutside(ref, () => closeModal())

  function playVideo(state) {
    setIsActive(state)
  }

  function playFromBeginning() {
    refPlayer.current.player.seekTo(0)
    setIsMuted(false)
  }

  return (
    <section className="videoComponent">
      <div className="videoComponent__bottomOverlay"></div>
      <div className="wrapper">
        <div
          ref={ref}
          className={`video ${showModal ? "video--hidden" : ""}`}
          onMouseOver={() => playVideo(true)}
          onMouseLeave={() => playVideo(false)}
        >
          {isMuted && (
            <div
              onClick={() => playFromBeginning()}
              className="bg--helper"
            ></div>
          )}
          <div
            style={{
              display: wasPlayed ? "none" : "block",
            }}
            className="video__poster"
          >
            <img
              src="https://i.vimeocdn.com/video/1572550964-932a73e835f8e81c280079cd7613b9c631836198d5f62b30f949c58a976a498e-d?mw=2400&mh=1350&q=70"
              alt="Showreel cover"
            />
          </div>
          {isMuted && (
            <span
              onClick={() => playFromBeginning()}
              className={`video__btn ${isActive ? "video__btn--dark" : ""}`}
            >
              <svg
                width="160px"
                height="160px"
                viewBox="0 0 160 160"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <title>Play button</title>
                <g
                  id="button/video/default"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <circle
                    id="Oval"
                    fill="#FFFFFF"
                    cx="80"
                    cy="80"
                    r="80"
                  ></circle>
                  <path
                    d="M86.682357,68.6169997 L101.019026,90.9184848 C101.61633,91.8476249 101.347324,93.0850526 100.418184,93.682357 C100.09559,93.8897392 99.7201722,94 99.336669,94 L70.663331,94 C69.5587615,94 68.663331,93.1045695 68.663331,92 C68.663331,91.6164968 68.7735918,91.2410795 68.980974,90.9184848 L83.317643,68.6169997 C83.9149474,67.6878596 85.1523751,67.4188536 86.0815152,68.0161579 C86.3225205,68.1710899 86.527425,68.3759944 86.682357,68.6169997 Z"
                    id="Triangle"
                    fill="#111111"
                    transform="translate(85.000000, 80.000000) rotate(-270.000000) translate(-85.000000, -80.000000) "
                  ></path>
                </g>
              </svg>
            </span>
          )}
          <ReactPlayer
            url="https://player.vimeo.com/video/783253697"
            width="100%"
            height="100%"
            className="react-player"
            playing={isPlaying}
            controls={true}
            loop={true}
            volume={0.5}
            muted={isMuted}
            ref={refPlayer}
            playsinline
          />
        </div>
      </div>
    </section>
  )
}

export default VideoComponent

function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }

      handler(event)
    }

    document.addEventListener("mousedown", listener)
    document.addEventListener("touchstart", listener)

    return () => {
      document.removeEventListener("mousedown", listener)
      document.removeEventListener("touchstart", listener)
    }
  }, [ref, handler])
}
